import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SendArrow } from '@yme/assets/icons/destinations';
import { SIZE_48, TRAILING_ICON } from '@yme/atoms/button';
import { Image } from '@yme/atoms/image';
import { useWindowSize } from '@yme/common/hooks';
import { getDestinationAnalyticsData } from '@yme/components/Destinations/ExperienceDetailsPage/helpers';
import { getRelatedUnits } from '@yme/components/Destinations/redux/selectors';
import { Link } from '@yme/components/Link';
import { ButtonLink } from '@yme/molecules/buttons';
import { getCommon, getPDPLinks } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { formatPrice } from '@yme/utils/formatPrice';
import { getProductURL } from '@yme/utils/product';
import { getExperienceDetailsPageState } from '../../../../redux/selectors';
import { CardHeader } from '../CardHeader';
import { Overview } from '../Overview';
import { CardInfoWrapperStyled, LogoStyled, PartnerLogoWrapper, PriceStyled, PriceWrapperStyled, } from './styled';
export function CardInfo({ formUrl, partnerDetailsPagePath, isLoaded, isInEditor }) {
    const { language, isInAuthor } = useSelector(getCommon);
    const experienceDetailsData = useSelector(getExperienceDetailsPageState);
    const relatedUnits = useSelector(getRelatedUnits);
    const pdpLinks = useSelector(getPDPLinks);
    const { partnerReference, expPrice, currencyCode } = experienceDetailsData;
    const { isTabletView, isInfiniteDesktopView } = useWindowSize();
    const { t } = useTranslation();
    const analyticsData = getDestinationAnalyticsData(experienceDetailsData, relatedUnits, pdpLinks);
    const slug = partnerReference?._path.split('/').at(-1);
    const partnerUrl = getProductURL({
        path: partnerDetailsPagePath,
        isInAuthor,
        slug,
    });
    const isPartnerDetailsPageExists = Boolean(slug && partnerDetailsPagePath);
    const formattedPrice = formatPrice({
        locale: language,
        currencyName: currencyCode,
        price: expPrice,
    });
    const sendAnalyticsData = useCallback(() => {
        setDigitalData(DigitalDataMutation.EDP_SEND_INQUIRY_VIEW, {
            data: analyticsData,
        });
    }, [analyticsData]);
    return (React.createElement(CardInfoWrapperStyled, null,
        React.createElement(FlexWrapper, { flexDirection: isTabletView ? 'row-reverse' : 'column', justifyContent: "space-between" },
            isInfiniteDesktopView && (React.createElement(CardHeader, { isLoaded: isLoaded, isInEditor: isInEditor })),
            React.createElement(PartnerLogoWrapper, null,
                React.createElement(FlexWrapper, { mb: "12px" },
                    React.createElement(RegularTextLevel3, { weight: 500 },
                        t('destinations_experiencePartnerPrefix_label'),
                        ":\u00A0"),
                    React.createElement(RegularTextLevel3, { to: isPartnerDetailsPageExists && partnerUrl, color: colorCoreBlack300, weight: 500, as: isPartnerDetailsPageExists ? Link : '' }, partnerReference?.partnerName)),
                React.createElement(LogoStyled, { to: isPartnerDetailsPageExists && partnerUrl, as: isPartnerDetailsPageExists ? Link : '' },
                    React.createElement(Image, { src: partnerReference?.partnerLogo?._path ?? '', alt: partnerReference?.partnerName }))),
            React.createElement(Overview, null)),
        React.createElement(PriceWrapperStyled, { justifyContent: "space-between", isFullWidth: true },
            React.createElement(RegularTextLevel3, null, t('destinations_experienceStartingPrice_label')),
            React.createElement(PriceStyled, null, formattedPrice)),
        formUrl && (React.createElement(ButtonLink, { buttonLink: formUrl, onClick: sendAnalyticsData, buttonLabel: t('destinations_experienceSendInquiry_button'), hasIconButton: TRAILING_ICON, iconComponent: SendArrow, size: SIZE_48 }))));
}
